module.exports = __webpack_public_path__ + "assets/windows-server.542a09b2.svg";